import React from 'react';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'form-item';
var FeedbackSpan = aggregatedClasses('span')(blockName, 'feedback');

var Feedback = function Feedback(_ref) {
  var text = _ref.text,
      hasError = _ref.hasError;
  if (!text) return null;
  return /*#__PURE__*/React.createElement(FeedbackSpan, {
    classProps: hasError
  }, text);
};

export default Feedback;
//# sourceMappingURL=Feedback.js.map
